import { FC } from 'react';
import { ContentContainer } from './ContentContainer';
import { NextShiftSection } from './shifts/NextShiftSection';
import SummarySection from './summary/SummarySection';

interface HomeContentsStaffProps {}

export const HomeContentsStaff: FC<HomeContentsStaffProps> = () => {
  return (
    <ContentContainer className="flex flex-col gap-5 md:max-w-none md:mx-0">
      <NextShiftSection />
      <SummarySection />
    </ContentContainer>
  );
};
